const IsLoggedIn = () => {
  if (localStorage.getItem('token')) {
    return true;
  } else {
    return false
  }
};

const AuthService = { IsLoggedIn };
export default AuthService;